import validate from 'mixins/validate';
import phone from 'mixins/phone-validation';
import signups from 'mixins/signups';
import { decode } from 'utils/general';
import 'lib/vue-phone-input.js';

const staticValues = {
  year: '2015',
};

const ATTENTIVE_CREATIVE_ID = '67732';

export default {
  components: {
    checkbox: () => import('../checkbox/checkbox.vue'),
    'select-input': () =>
    import('../select-input/select-input.vue'),
  },
  props: [
    'frequencies',
    'base-url',
    'months',
    'firstStateText',
    'unsubscribeStateText',
    'unsubscribeCheckboxes',
    'hostedPageUrl',
  ],
  data() {
    return {
      firstNameValue: '',
      emailValue: '',
      zipCode: '',
      countryValue: '',
      birthday: [],
      frequency: '',
      unsubscribe: false,
      birthdayRequired: false,
      acceptMarketing: false,
      formState: 'edit',
      unsubscribeCheckboxValue: '',
    };
  },
  mixins: [validate, phone, signups],
  mounted() {
    // opacity animation on init
    document
      .querySelector('.preferences-wrapper')
      .classList.add('form-initialized');

    // get first available option value
    const unsubscribeDefaultValue = this.checkboxesUnsubscribe;
    this.unsubscribeCheckboxValue = unsubscribeDefaultValue[0].label;
  },
  methods: {
    changeForm(state) {
      this.formState = state;
    },
    subscribeUser() {
      // update user preferences
      let sanitizeBirthday = '';

      if (this.birthday[0] !== 'placeholder') {
        sanitizeBirthday = this.birthday.join('/');
      }

      const formdata = new FormData();
      formdata.append('$fields', 'Frequency, Birthday, Accepts Marketing');
      formdata.append('$list_fields', 'Frequency, Birthday, Accepts Marketing');
      formdata.append('$email', this.emailValue);
      formdata.append('$country', this.countryValue);
      formdata.append('$zip', this.zipCode);
      formdata.append(
        '$phone_number',
        this.phoneValue.replaceAll(' ', '') || '',
      );
      formdata.append('$first_name', this.firstNameValue);
      formdata.append('Accepts Marketing', this.acceptMarketing);
      formdata.append('Frequency', this.frequency);
      formdata.append('Birthday', sanitizeBirthday);

      this.fetchRequest(formdata);
      this.submitToAttentive(ATTENTIVE_CREATIVE_ID);
    },
    fetchRequest(formdata) {
      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow',
        mode: 'no-cors',
      };

      fetch(this.hostedPageUrl, requestOptions)
        .then((response) => response.text())
        .then(() => this.changeForm('success'))
        .catch((error) => console.log('error', error));
    },
    parsedData(type) {
      let data = {};
      switch (type) {
        case 'frequencies':
          data = JSON.parse(decode(this.frequencies));
          break;
        case 'months':
          data = JSON.parse(decode(this.months));
          break;
        default:
          break;
      }

      return data;
    },
    submitForm() {
      const isValid = this.validateCustomForm();

      if (isValid) {
        this.subscribeUser();
      }
    },
    validateCustomForm() {
      const checkPhone = this.phoneValidation();
      const countrySelectDropdown = this.$refs['countryDropdown'];
      const frequencyDropdown = this.$refs['frequenciesDropdown'];
      const daysDropdown = this.$refs['daysDropdown'];
      const monthsDropdown = this.$refs['monthsDropdown'];

      let isValid = this.$children
        .filter((c) => typeof c.validateInput !== 'undefined')
        .map((c) => {
          const validInput = c.validateInput();
          this.highlightErrors(c, validInput);

          return c.validateInput();
        })
        .every((res) => res);

      // check if country region select is not empty
      if (countrySelectDropdown.inputValue === 'placeholder') {
        countrySelectDropdown.isValid = false;
        isValid = false;
      }

      // check if frequency was selected
      if (frequencyDropdown.inputValue === 'placeholder') {
        frequencyDropdown.isValid = false;
        isValid = false;
      }

      // check if birthday is required
      if (this.birthdayRequired) {
        if (daysDropdown.inputValue === 'placeholder') {
          daysDropdown.isValid = false;
          isValid = false;
        }

        if (monthsDropdown.inputValue === 'placeholder') {
          monthsDropdown.isValid = false;
          isValid = false;
        }
      }

      // check if user added a phone and if its valid
      if (!checkPhone) {
        isValid = false;

        this.phoneValidation(true);
      }

      return isValid;
    },
    highlightErrors(element, isValid) {
      if (!isValid) {
        element.dirty = true;
        element.isValid = false;
      }
    },
    onInputChange({ name, value }) {
      const match = /\[(\w*)\]/.exec(name);
      const countrySelectDropdown = this.$refs['countryDropdown'];
      const frequencyDropdown = this.$refs['frequenciesDropdown'];
      const daysDropdown = this.$refs['daysDropdown'];
      const monthsDropdown = this.$refs['monthsDropdown'];

      if (!match || !match[1]) {
        return false;
      }

      if (
        (match[1] === 'Day' || match[1] === 'Month') &&
        value !== 'placeholder'
      ) {
        this.birthdayRequired = true;
        this.birthday[2] = staticValues.year;
      }

      switch (match[1]) {
        case 'first_name':
          this.firstNameValue = value;
          break;
        case 'email':
          this.emailValue = value;
          break;
        case 'sms':
          this.phoneSendSMS = !!value;
          break;
        case 'zip':
          this.zipCode = value;
          break;
        case 'accepts_marketing':
          this.acceptMarketing = !!value;
          break;
        case 'country':
          countrySelectDropdown.isValid = true;
          this.countryValue = value;
          break;
        case 'Frequency':
          frequencyDropdown.isValid = true;
          this.frequency = value;
          break;
        case 'Month':
          monthsDropdown.isValid = true;
          this.birthday[0] = value;
          break;
        case 'Day':
          daysDropdown.isValid = true;
          this.birthday[1] = value;
          break;
        default:
          break;
      }

      this.phoneValidation(true);
    },
    generateCountryArray() {
      return Object.keys(Countries).map((label) => ({
        label,
        value: label,
      }));
    },
    generateFrequencies() {
      return Object.keys(this.parsedData('frequencies')).map((label) => ({
        label,
        value: label,
      }));
    },
    generateMonths() {
      const arr = this.parsedData('months');

      return Object.keys(arr).map((label) => ({
        label,
        value: arr[label].numeric,
      }));
    },
    generateDays() {
      const arr = [];
      const maxDays = 31;

      for (let index = 0; index < maxDays; index++) {
        const obj = {
          label: index,
          value: index,
        };

        arr.push(obj);
      }

      return arr;
    },
    changeCheckbox(value) {
      this.unsubscribeCheckboxValue = value;
    },
    submitUnsubscribe() {
      const mailformat = /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      const formdata = new FormData();
      const isUnsubscribed = this.unsubscribeCheckboxValue === 'Unsubscribed';

      formdata.append('$fields', 'Frequency');
      formdata.append('$list_fields', 'Frequency');
      formdata.append('$email', this.emailValue);
      formdata.append('Frequency', this.unsubscribeCheckboxValue);

      if (isUnsubscribed) {
        formdata.append('$unsubscribe', true);
      }

      if (!this.emailValue.match(mailformat)) {
        const emailInput = this.$refs['email'];

        emailInput.isValid = false;
        emailInput.dirty = true;

        this.changeForm('edit');

        return;
      }

      this.fetchRequest(formdata);
    },
  },
  computed: {
    checkboxesUnsubscribe() {
      const checkboxes = JSON.parse(decode(this.unsubscribeCheckboxes));
      const checkboxesObject = Object.keys(checkboxes).map((label) => ({
        label,
        value: label,
      }));
      return checkboxesObject;
    },
  },
};
